

























































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import UUIFComponents from '@/shared/uuifComponent';
import { SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwCheckbox } from '@sonicwall/unified-ui-framework/src/shared/sw-checkbox';
import { SwActionBar, SwActionBarItem } from '@sonicwall/unified-ui-framework/src/shared/sw-action-bar';
import { currentUserKey } from '../msw-constants';
import * as decode from 'jwt-decode';
import { SwIconButton } from '@libs-uuif/shared/sw-icon-button';
const cssPrefix = 'super-admin-modal';

@Component({
  components: {
    ...UUIFComponents,
    SwActionBar,
    SwActionBarItem,
    SwCheckbox,
    SwIconButton,
  },
})

export default class AddOrUpdateSuperAdminModal  extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required: true , type: Boolean , default : false })
  openModal: boolean;

  @Prop({ type: Boolean , default : false })
  isDashboard: boolean;

  adminList: any = [];
  adminFields: any = [];
  acceptTandC: boolean = false;
  currentFieldsCount: number = 10;

  get isOrgBased() {
    const currentUser: any = localStorage.getItem(currentUserKey);
    const token: any = decode(JSON.parse(currentUser)?.token || '');
    return token?.orgbased === 'YES';
  }

  get modalTitle() {
    return this.isOrgBased ? this.$t('accessMgmt.updateSuperAdmin') : this.$t('accessMgmt.assignSuperAdmin');
  }

  get getWidth() {
    const width: any = '58rem';
    return width;
  }

  get adminListFromStore() {
    return this.$store.getters['AccessManagementStoreModule/getAdminList'];
  }

  get adminOptions(): SelectOption[] {
    return this.adminList?.map((ele: any) => {
      return {
        id: ele?.emailAddress,
        value: ele?.emailAddress,
        label: ele?.emailAddress,
      };
    });
  }

  closeModal(val: boolean) {
    this.$emit('closeModal', val);
  }

  onDelete(index: number) {
    this.adminFields[index].emailAddress = '';
    this.removeSelectedAdminsFromList();
  }

  onChangeSuperAdmin() {
    this.removeSelectedAdminsFromList();
  }

  onUpdate() {
    const adminList = this.adminFields?.map((ele: any, index: any) => {
      return { emailAddress: ele?.emailAddress, saOrderId:  index + 1 };
    })
    ?.filter((ele: any) => ele?.emailAddress !== '');
    if (adminList?.length <= 0) {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: this.$t('accessMgmt.superAdminValidation') });
      return;
    }
    const request: any = { adminList };
    this.$store.dispatch('AccessManagementStoreModule/manageSuperAdmins', request)
    .then((res: any) => {
      this.$store.commit('stopLoading');
      if (res?.operationStatus === 'OK') {
        this.$store.commit('AccessManagementStoreModule/setAdminList', res?.adminList || []);
        this.$store.commit('AccessManagementStoreModule/setTriggerUserGroupApi', true);
        this.closeModal(true);
        this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: res?.msgDesc });
      } else {
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: res?.msgDesc });
      }
    })
    .catch(() => {
      this.$store.commit('stopLoading');
    });
  }

  removeSelectedAdminsFromList() {
    const selectedAdmins: any = [];
    this.adminFields.forEach((admin: any) => admin?.emailAddress && selectedAdmins.push(admin?.emailAddress));
    const removedSelectedAdmins = this.adminListFromStore?.map((ele: any) => !selectedAdmins?.includes(ele?.emailAddress) && ele)
    .filter(Boolean);
    this.adminList = removedSelectedAdmins;
  }

  generateFields() {
    for (let i = 0; i < this.currentFieldsCount; i = i + 1) {
      this.adminFields.push({ emailAddress: '' });
    }
  }

  addNewField() {
    if (this.currentFieldsCount < 10) {
      this.adminFields.push({ emailAddress: '' });
      this.currentFieldsCount += 1;
    }
  }

  populateSelectedAdmins() {
    this.generateFields();
    this.adminList?.forEach((admin: any) => {
      if (admin?.isSelectedSuperAdmin?.toLowerCase() === 'true') {
        this.adminFields[admin?.saOrder - 1].emailAddress = admin?.emailAddress;
      }
    });
  }

  mounted() {
    this.adminList = this.adminListFromStore;
    if (this.adminList.length > 5) {
      this.currentFieldsCount = this.adminList.length;
    }
    this.populateSelectedAdmins();
    this.removeSelectedAdminsFromList();
  }

}
